onComplete(function() {
	// Editors edit every floor plan and menu item in place, so the visitor-only widgets stay off in edit modes.
	var editing = function() {
		var mode = document.documentElement.getAttribute('data-editor-mode') || document.body.getAttribute('data-editor-mode');
		return mode === 'content' || mode === 'layout';
	};

	// Floor plans: the plan titles become tabs above the plans, as on the old product pages.
	var setupPlans = function() {
		document.querySelectorAll('.catalog-plans').forEach(function(panel) {
			var previousNav = panel.querySelector('.catalog-plans-nav');
			if (previousNav) {
				previousNav.remove();
			}
			panel.classList.remove('has-tabs');
			var plans = Array.prototype.slice.call(panel.querySelectorAll('.catalog-plan'));
			if (!plans.length || editing()) {
				return;
			}

			var nav = document.createElement('ul');
			nav.className = 'catalog-plans-nav';
			nav.setAttribute('role', 'tablist');
			plans.forEach(function(plan, index) {
				var title = plan.querySelector('.catalog-plan-title');
				var item = document.createElement('li');
				var button = document.createElement('button');
				button.type = 'button';
				button.setAttribute('role', 'tab');
				button.textContent = title ? title.textContent.trim() : '';
				button.addEventListener('click', function() {
					plans.forEach(function(other, otherIndex) {
						other.classList.toggle('active', otherIndex === index);
						nav.children[otherIndex].firstChild.classList.toggle('active', otherIndex === index);
						nav.children[otherIndex].firstChild.setAttribute('aria-selected', otherIndex === index ? 'true' : 'false');
					});
				});
				item.appendChild(button);
				nav.appendChild(item);
			});
			panel.insertBefore(nav, panel.firstChild);
			panel.classList.add('has-tabs');
			nav.firstChild.firstChild.click();
		});
	};

	// Assortment menu: phones get a select box with the series, like the old shop menu.
	var setupCatalogSelect = function() {
		document.querySelectorAll('.catalog-menu').forEach(function(menu) {
			var previous = menu.querySelector('.catalog-menu-select');
			if (previous) {
				previous.remove();
			}
			menu.classList.remove('has-select');
			var links = menu.querySelectorAll('.navlist .nav-link');
			if (!links.length || editing()) {
				return;
			}

			var select = document.createElement('select');
			select.className = 'form-control catalog-menu-select';
			var label = menu.querySelector('.catalog-menu-select-label');
			if (label) {
				select.setAttribute('aria-label', label.textContent.trim());
			}
			links.forEach(function(link) {
				var option = document.createElement('option');
				option.value = link.href;
				option.textContent = link.textContent.trim();
				option.selected = link.classList.contains('active');
				select.appendChild(option);
			});
			select.addEventListener('change', function() {
				window.location.href = select.value;
			});
			menu.appendChild(select);
			menu.classList.add('has-select');
		});
	};

	// Dealer cards: all cards share the height of the tallest one, as on the old dealer page.
	var equalCards = function() {
		document.querySelectorAll('.section-cards-row').forEach(function(row) {
			var cards = row.querySelectorAll('.section-card-inner');
			cards.forEach(function(card) {
				card.style.minHeight = '';
			});
			if (window.innerWidth < 768) {
				return;
			}
			var tallest = 0;
			cards.forEach(function(card) {
				tallest = Math.max(tallest, card.offsetHeight);
			});
			cards.forEach(function(card) {
				card.style.minHeight = tallest + 'px';
			});
		});
	};

	// Catalogue cards: photos keep their own ratio and every photo area on the page takes the tallest photo, as on the old shop.
	var equalPhotos = function() {
		var areas = Array.prototype.slice.call(document.querySelectorAll('.catalog-content .catalog-card-image'));
		areas.forEach(function(area) {
			area.style.minHeight = '';
		});
		if (window.innerWidth < 768) {
			return;
		}
		var tallest = 0;
		areas.forEach(function(area) {
			tallest = Math.max(tallest, area.offsetHeight);
		});
		areas.forEach(function(area) {
			area.style.minHeight = tallest + 'px';
		});
	};

	// Options of a colour or option group all share the height of the tallest option, as on the old product pages.
	var equalOptions = function() {
		document.querySelectorAll('.catalog-option-group').forEach(function(group) {
			var options = group.querySelectorAll('.catalog-option');
			options.forEach(function(option) {
				option.style.minHeight = '';
			});
			if (window.innerWidth < 768) {
				return;
			}
			var tallest = 0;
			options.forEach(function(option) {
				tallest = Math.max(tallest, option.offsetHeight);
			});
			options.forEach(function(option) {
				option.style.minHeight = tallest + 'px';
			});
		});
	};

	// Gallery thumbnails share the height of the tallest photo in the album, at most 100px, as on the old product pages.
	var equalThumbs = function() {
		document.querySelectorAll('.catalog-item-gallery [data-partial="image-album"]').forEach(function(album) {
			var images = Array.prototype.slice.call(album.querySelectorAll('img[width][height]'));
			images.forEach(function(img) {
				img.style.height = '';
			});
			if (window.innerWidth < 992) {
				return;
			}
			var tallest = 0;
			images.forEach(function(img) {
				tallest = Math.max(tallest, img.offsetWidth * img.getAttribute('height') / img.getAttribute('width'));
			});
			images.forEach(function(img) {
				img.style.height = Math.min(100, Math.round(tallest)) + 'px';
			});
		});
	};
	equalThumbs();
	window.addEventListener('resize', equalThumbs);

	// Floor plans show at their own width at most, centred like on the old product pages.
	var limitPlans = function() {
		document.querySelectorAll('.catalog-plan img[width]').forEach(function(img) {
			img.style.maxWidth = 'min(100%, ' + img.getAttribute('width') + 'px)';
		});
	};
	limitPlans();

	// The CMS sizes photos for the desktop column width; on smaller screens a photo can be wider than that,
	// so each picture gets its measured width, corrected for photos that are cropped to fill their box.
	// Only photos that fill their box are measured: a photo shown at its own size (such as a colour swatch)
	// takes its width from these sizes, so measuring it would shrink it a little further on every run.
	var fitSizes = function() {
		document.querySelectorAll('#page picture, .nav-footer picture').forEach(function(picture) {
			var img = picture.querySelector('img');
			var box = picture.parentElement;
			if (!img || !box) {
				return;
			}
			var width = img.getBoundingClientRect().width;
			var height = img.getBoundingClientRect().height;
			var boxStyle = getComputedStyle(box);
			var boxWidth = box.clientWidth - parseFloat(boxStyle.paddingLeft) - parseFloat(boxStyle.paddingRight);
			if (!width || width < boxWidth - 1) {
				return;
			}
			var ratio = img.getAttribute('width') && img.getAttribute('height') ? img.getAttribute('width') / img.getAttribute('height') : 0;
			if (ratio && getComputedStyle(img).objectFit === 'cover') {
				width = Math.max(width, height * ratio);
			}
			var sizes = Math.ceil(width) + 'px';
			picture.querySelectorAll('source, img').forEach(function(source) {
				if (source.getAttribute('sizes') !== sizes) {
					source.setAttribute('sizes', sizes);
				}
			});
		});
	};

	setupPlans();
	setupCatalogSelect();
	equalCards();
	equalPhotos();
	equalOptions();
	window.addEventListener('load', equalOptions);
	window.addEventListener('resize', equalOptions);

	// Lazy photos arrive after the page load, so the shared heights are measured again when one of them loads.
	var remeasure = null;
	document.addEventListener('load', function(event) {
		if (
			event.target.tagName !== 'IMG'
			|| !event.target.closest('.catalog-option, .catalog-card-image, .section-card')
		) {
			return;
		}
		clearTimeout(remeasure);
		remeasure = setTimeout(function() {
			equalCards();
			equalPhotos();
			equalOptions();
			fitSizes();
		}, 50);
	}, true);
	fitSizes();
	window.addEventListener('load', fitSizes);
	window.addEventListener('resize', fitSizes);
	window.addEventListener('load', equalPhotos);
	window.addEventListener('resize', equalPhotos);
	window.addEventListener('load', equalCards);
	window.addEventListener('resize', equalCards);

	// Switching between viewing and editing reloads the partials, which drops the tabs' state and would hide
	// every floor plan; the widgets are rebuilt for the new mode (no tabs while editing, so every plan is editable).
	// The editor is created after this script runs, so it is looked up for a while when the admin bar is present.
	var rebuild = function() {
		limitPlans();
		setupPlans();
		setupCatalogSelect();
		equalCards();
		equalPhotos();
		equalOptions();
		fitSizes();
	};
	var watchEditor = function(tries) {
		if (window.editor && window.editor.addEventListener) {
			window.editor.addEventListener('reloaded', rebuild);
			window.editor.addEventListener('changed-mode', rebuild);
		} else if (tries > 0) {
			setTimeout(function() {
				watchEditor(tries - 1);
			}, 250);
		}
	};
	if (document.getElementById('adminbar')) {
		watchEditor(40);
	}
});
